import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { mapByIds } from '@wix/form-mapper';

import { applyItemPropertiesOverride } from './apply-item-properties-override';
import { evaluateOverrideConditionFactory } from './evaluate-override-condition';
import { type Submission } from './submission';
import { asRequired, isFormRuleValid } from './utils';

export function applyOverrides(
  formSchema: Form,
  submission?: Submission,
): Form {
  const nestedForms = (formSchema?.nestedForms || []).flatMap(
    ({ targets, form }) =>
      (targets || []).map((target) => ({
        form: applyFormOverrides(
          asRequired(form),
          (submission || {})[target] as Submission,
        ),
        targets: [target],
      })),
  );
  return { ...applyFormOverrides(formSchema, submission), nestedForms };
}

function applyFormOverrides(formSchema: Form, submission?: Submission): Form {
  const submissionsById = mapByIds(submission as Submission, formSchema);
  const { rules } = formSchema;
  if (rules) {
    return rules
      .filter((rule) => isFormRuleValid(rule, formSchema))
      .filter((rule) =>
        evaluateOverrideConditionFactory()(rule, submissionsById),
      )
      .reduce(
        (form, rule) => applyItemPropertiesOverride(form, rule),
        formSchema,
      );
  }
  return formSchema;
}
